import { Controller, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import "regenerator-runtime/runtime";

class UserManager extends Controller {
	constructor(name) {
		super(name);
		this.remoteClassName = "user";
	}

	async getList () {
		const rd = NousCore.api.createRequest();
	
		return NousCore.api.send("user/get-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const userList = Shark.getInstanceList("User", data.items);
	
						userList.sort((a, b) => {
							// console.log(a.lastName.toLowerCase(), b.lastName.toLowerCase(), (a.lastName.toLowerCase() > b.lastName.toLowerCase()))
							if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
								return 1;
							}
							else if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
								return -1;
							}
							else {
								if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) {
									return 1;
								}
								else if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) {
									return -1;
								}
							}
						});
	
						const areaManagerList = userList.filter(function (item) {
							return item.hasRole("areaManager");
						});
						const agentList = userList.filter(function (item) {
							return item.hasRole("sellRepresentative");// && item.status === 1;
						});
						const intermediaryList = userList.filter(function (item) {
							return item.hasRole("intermediary");
						});

						const activeAgentList = agentList.filter(item => item.status === 1);
						const inactiveAgentList = agentList.filter(item => item.status === 8);
	
						Shark.set({
							activeAgentList,
							agentList,
							areaManagerList,
							inactiveAgentList,
							intermediaryList,
							userList,
						});
	
						userManager.emit("listChanged");
						return {
							data: userList,
							requestedAction: "get-list",
							status: "ok",
						};
					}
					case 404:
						userManager.emit("listGetError");
						return {
							data: null,
							requestedAction: "get-list",
							status: "ko",
						};

				}
			}
		});
	}

	getRequireAttentionCounts () {
		const rd = NousCore.api.createRequest();
		const action = "get-require-attention-counts";

		return NousCore.api.send(`user/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const counters = data.items[0];
						const requireAttentionItems = Shark.getInstance("__smart__", {
							constructionSiteCardCount: parseInt(counters.constructionSiteCardCount),
							constructionSiteCount: parseInt(counters.constructionSiteCount),
							guid: counters.guid,
							leadCount: parseInt(counters.leadCount),
							quotationCount: parseInt(counters.quotationCount),
							reportCount: parseInt(counters.reportCount),
							siteInfoSheetUploadedCount: parseInt(counters.siteInfoSheetUploadedCount),
							siteInfoSheetWaitingCount: parseInt(counters.siteInfoSheetWaitingCount),
						});
						requireAttentionItems.siteInfoSheetCount = requireAttentionItems.siteInfoSheetUploadedCount + requireAttentionItems.siteInfoSheetWaitingCount;

						for (let prop in requireAttentionItems) {
							if (requireAttentionItems[prop] === 0) {
								requireAttentionItems[prop] = null;
							}
						}

						Shark.set({requireAttentionItems});

						return {
							data: data,
							requestedAction: action,
							status: "ok",
						};
					}
					case 99:
						return {
							data: null,
							error: data.error,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}

	logIn (user) {
		const rd = NousCore.api.createRequest({ item: user.export("logIn") });
		const requestedAction = "login";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						user.clean();

						return {
							data: user,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data: null,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	save (user) {
		const rd = NousCore.api.createRequest({ item: user.export() });
		const requestedAction = user.guid === "" ? "insert" : "update";

		return NousCore.api.send(`user/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						user.clean();
						userManager.emit("userSaved");
						return {
							data: user,
							requestedAction,
							status: "ok",
						};
					case 9:
					case 99:
						userManager.emit("userSaveError");
						return {
							data: null,
							errors: data.errors,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	sendMessage (message) {
		const rd = NousCore.api.createRequest({ item: message.collectData() });

		return NousCore.api.send("user/send-message", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const result = data.items[0];

						if (result.sendResult) {
							userManager.emit("messageSent");
						}
						return {
							data: result,
							requestedAction: "send-message",
							status: "ok"
						};
					}
					case 404:
						return {
							data: null,
							error: data.error,
							requestedAction: "send-message",
							status: "ko"
						};
				}
			}
		});
	}

	sendMessages (messageList) {
		const rd = NousCore.api.createRequest({ items: messageList.map(message => message.export()) });

		return NousCore.api.send("user/send-messages", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction: "send-messages",
							status: "ok"
						};
					case 404:
						return {
							data: null,
							error: data.error,
							requestedAction: "send-messages",
							status: "ko"
						};
				}
			}
		});
	}

	
	delete (user) {
		const rd = NousCore.api.createRequest({ item: user.export() });

		NousCore.api.send(`user/delete`, rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
					//Dave.ToDo: rimuovere l'utente dalla lista
						userManager.emit("deleted");
						break;
					case 99:
						userManager.emit("error");
						break;
				}
			}
		});
	}

	register (user) {
		const rd = NousCore.api.createRequest({ item: user.export("register") });

		NousCore.api.send("user/register", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						userManager.emit("userRegistered");
						break;
					case 99:
						userManager.emit("userRegistrationError");
						break;
				}
			}
		});
	}

	upload (target) {
		NousCore.api.uploadFiles(target, "user/upload-picture").then(function(jsonData) {
			const savedFile = jsonData.payload.items[0];

			switch (savedFile.rc) {
				case 1: {
					const user = Shark.get("editingUser");
					user.set("pictureURL", "/" + savedFile.filePath);
					userManager.emit("fileUploaded", savedFile.filePath);
					break;
				}
				case 95: {
					let data = {
						tempFile: savedFile.errors[0].erroData.tempFile,
						originalName: savedFile.errors[0].erroData.originalName,
						type: "pictureURL"
					};
					userManager.emit("fileAlreadyPresentError", data);
					break;
				}
				default:
					alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
			}

			Shark.render();
		});
	}

	uploadDuplicate (datas) {
		const rd = NousCore.api.createRequest({ item: { tempFile: datas.tempFile, originalName: datas.originalName }});

		NousCore.api.send("user/confirm-temp-dupe-file", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const editingUser = Shark.get("editingUser");
						editingUser.set(datas.type, data.items[0].filePath);
						Shark.render();
						break;
					}
					case 404:
						userManager.emit("userSaveError");
						break;
				}
			}
		});
	}
}

const userManager = new UserManager("userManager");

Shark.registerController(userManager);

export { userManager };
